/* manifestinyou Theme JS */
(function () {
  'use strict';

  /* ── Cart count sync ── */
  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        ['cart-count', 'cart-count-mobile'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.textContent = count;
        });
      })
      .catch(function () {});
  }

  /* ── Mobile drawer (sidebar) ── */
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var nav        = document.getElementById('mw-navigation');
  var scrim      = document.getElementById('drawer-scrim');

  function openDrawer() {
    if (!nav) return;
    nav.classList.add('drawer-open');
    if (scrim) scrim.classList.add('open');
    if (menuToggle) {
      menuToggle.textContent = '✕';
      menuToggle.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden'; // prevent background scroll
  }

  function closeDrawer() {
    if (!nav) return;
    nav.classList.remove('drawer-open');
    if (scrim) scrim.classList.remove('open');
    if (menuToggle) {
      menuToggle.textContent = '☰';
      menuToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  function toggleDrawer() {
    if (nav && nav.classList.contains('drawer-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', toggleDrawer);
  if (scrim)      scrim.addEventListener('click', closeDrawer);

  // Close drawer on link tap (navigate away)
  if (nav) {
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        setTimeout(closeDrawer, 80);
      });
    });
  }

  // Close drawer on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Mobile search bar toggle ── */
  var searchToggle = document.getElementById('mobile-search-toggle');
  var searchBar    = document.getElementById('mobile-search-bar');

  function toggleSearch() {
    if (!searchBar) return;
    var isOpen = searchBar.classList.toggle('open');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      var input = searchBar.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  }

  if (searchToggle) searchToggle.addEventListener('click', toggleSearch);

  /* ── Run on load ── */
  document.addEventListener('DOMContentLoaded', syncCartCount);

})();
